var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/Heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04865 9.45519C0.799995 6.37829 2.75414 2.91675 5.78298 2.91675C7.47618 2.91675 8.84943 3.68598 9.99935 5.22444L10.1443 5.03614C11.2643 3.62321 12.5931 2.91675 14.2157 2.91675C17.2446 2.91675 19.1987 6.37829 17.9501 9.45519C17.4293 10.7383 16.2408 12.2877 14.3844 14.1034C13.2757 15.1877 11.9273 16.3369 11.0209 17.0868C10.4262 17.5789 9.57249 17.5789 8.97775 17.0868C8.07137 16.3369 6.723 15.1877 5.61434 14.1034C3.75791 12.2877 2.56935 10.7383 2.04865 9.45519Z",
    fill: "#FF3D8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritedIcon);
export default __webpack_public_path__ + "static/media/favorited-icon.9f08fc06ed376becaac23eb207e999c7.svg";
export { ForwardRef as ReactComponent };